import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function StepLabel(theme: Theme) {
  return {
    MuiStepLabel: {
      styleOverrides: {
        labelContainer: {
          color: theme.palette.text.disabled,
        },
      },
    },
  }
}
